// orchestratorFocus.ts — Select / scroll only (step 3 of chat sync).
//
// Responsibilities:
//   - switch tab if needed (receptor / peptide / docking)
//   - scroll to the list item
//   - select in list (same as a user click, via window.select*ById hooks)
//
// Does not create jobs, does not call backend, does not refresh list rows.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function parseNumericId(value) {
    if (value === undefined || value === null || value === '')
        return null;
    const n = typeof value === 'number' ? value : parseInt(String(value), 10);
    return Number.isNaN(n) ? null : n;
}
function scrollToElement(el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}
function activateTab(tabTarget) {
    const button = document.querySelector(`.tab-button[data-target="${tabTarget}"]`);
    if (!button || button.classList.contains('disabled'))
        return;
    const tabContents = document.querySelectorAll('.tab-content');
    tabContents.forEach(tab => tab.classList.add('hidden'));
    document.querySelectorAll('.tab-button').forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');
    const targetTab = document.getElementById(tabTarget);
    if (targetTab)
        targetTab.classList.remove('hidden');
}
function selectReceptorById(receptorID) {
    const fn = window.selectReceptorById;
    if (fn)
        return fn(receptorID);
    const el = document.querySelector(`.receptor-item[data-receptor-id="${receptorID}"]`);
    if (!el)
        return false;
    scrollToElement(el);
    el.click();
    return true;
}
function selectPeptideById(peptideID) {
    const fn = window.selectPeptideById;
    if (fn)
        return fn(peptideID);
    const el = document.querySelector(`.peptide-item[data-peptide-id="${peptideID}"]`);
    if (!el)
        return false;
    scrollToElement(el);
    el.click();
    return true;
}
function selectDockingById(dockingID) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { selectDockingById: selectFn } = yield import('./components/dockingForm');
            return selectFn(dockingID);
        }
        catch (_a) {
            const el = document.querySelector(`.docking-item[data-docking-id="${dockingID}"]`);
            if (!el)
                return false;
            scrollToElement(el);
            el.click();
            return true;
        }
    });
}
function selectScreeningById(screeningID) {
    const fn = window.selectScreeningById;
    if (fn)
        return fn(screeningID);
    const el = document.querySelector(`[data-screening-id="${screeningID}"]`);
    if (!el)
        return false;
    scrollToElement(el);
    el.click();
    return true;
}
/**
 * Apply orchestrator focus: switch tab if needed, scroll to item, select in list.
 * Priority: docking > screening > peptide > receptor (most specific wins).
 */
export function applyOrchestratorFocus(focus) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        if (!focus || Object.keys(focus).length === 0)
            return false;
        const receptorID = parseNumericId(focus.receptorID);
        const peptideID = parseNumericId(focus.peptideID);
        const dockingID = ((_a = focus.dockingID) === null || _a === void 0 ? void 0 : _a.trim()) || null;
        const screeningID = ((_b = focus.screeningID) === null || _b === void 0 ? void 0 : _b.trim()) || null;
        console.log('[orchestratorFocus] Applying focus:', { receptorID, peptideID, dockingID, screeningID });
        if (dockingID) {
            activateTab('docking-tab');
            const ok = yield selectDockingById(dockingID);
            if (ok)
                return true;
        }
        if (screeningID) {
            activateTab('receptor-tab');
            if (receptorID)
                selectReceptorById(receptorID);
            const ok = selectScreeningById(screeningID);
            if (ok)
                return true;
        }
        if (peptideID) {
            activateTab('peptide-tab');
            const ok = selectPeptideById(peptideID);
            if (ok)
                return true;
        }
        if (receptorID) {
            activateTab('receptor-tab');
            return selectReceptorById(receptorID);
        }
        console.warn('[orchestratorFocus] No matching item found for focus:', focus);
        return false;
    });
}
